/*
  A hacky fix to force a break after external links
  so they don't stack in a line.
*/

((doc, $) => {
  $(doc).on("bb:finalHandleData", (e, data) => {
    if (data && data.groups) {
      let externals = doc.querySelectorAll(".bb-external");
      externals.length &&
        externals.forEach(link => {
          link.insertAdjacentElement("afterEnd", doc.createElement("br"));
        });
    }
  });
})(document, jQuery);
